import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

import {FilterOperation} from "@vesta/vos-types/modules/workspaceLevel/domain/FilterOperation";

export type FilterConfigurationLineItem = {
    // columnId: Uuid;
    columnId: string;
} & (
        | {
            operation: FilterOperation.contains;
            value: string;
        }
        | {
            operation: FilterOperation.equals;
            value: unknown;
        }
        | {
            operation: FilterOperation.endsWith;
            value: unknown;
        }
        | {
            operation: FilterOperation.greaterThan;
            value: unknown;
        }
        | {
            operation: FilterOperation.greaterThanEqualTo;
            value: unknown;
        }
        | {
            operation: FilterOperation.in;
            values: Array<string>;
        }
        | {
            operation: FilterOperation.lessThan;
            value: unknown;
        }
        | {
            operation: FilterOperation.lessThanEqualTo;
            value: unknown;
        }
        | {
            operation: FilterOperation.notContains;
            value: unknown;
        }
        | {
            operation: FilterOperation.notEquals;
            value: unknown;
        }
        | {
            operation: FilterOperation.startsWith;
            value: unknown;
        }
        | {
            operation: FilterOperation.isNull;
            value: null;
        }
        | {
            operation: FilterOperation.isNotNull;
            value: null;
        }
    );
// // /**
// //  * null means no filter is applied
// //  */
// // values: Array<string> | null;
// values: Array<string>;

export type FilterConfiguration = {
    revisionId: Uuid;
    lineItems: Array<FilterConfigurationLineItem>;
};

/** Omits filters on `columnId` so filter dropdowns can load all distinct values for that column. */
export function filterConfigurationExcludingColumn(
    filterConfiguration: FilterConfiguration,
    columnId: string,
): FilterConfiguration {
    return {
        revisionId: filterConfiguration.revisionId,
        lineItems: filterConfiguration.lineItems.filter((lineItem) => lineItem.columnId !== columnId),
    };
}

export function filterOperationToDisplayName(filterOperation: FilterOperation): string {
    switch (filterOperation) {
        case FilterOperation.contains: {
            return "Contains";
        }
        case FilterOperation.equals: {
            return "Equals";
        }
        case FilterOperation.endsWith: {
            return "Ends with";
        }
        case FilterOperation.greaterThan: {
            return "Greater than";
        }
        case FilterOperation.greaterThanEqualTo: {
            return "Greater than or equal to";
        }
        case FilterOperation.in: {
            return "In";
        }
        case FilterOperation.lessThan: {
            return "Less than";
        }
        case FilterOperation.lessThanEqualTo: {
            return "Less than or equal to";
        }
        case FilterOperation.notContains: {
            return "Not contains";
        }
        case FilterOperation.notEquals: {
            return "Not equals";
        }
        case FilterOperation.startsWith: {
            return "Starts with";
        }
        case FilterOperation.isNull: {
            return "Is null";
        }
        case FilterOperation.isNotNull: {
            return "Is not null";
        }
        default: {
            console.error("Invalid filterOperation", filterOperation);
            // throw new Error("Invalid filterOperation");
            return "Unknown";
        }
    }
}
